import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export interface MaterialsByGroupParams {
  page?: number;
  perPage?: number;
  search?: string;
}

export default class ProductCategoryAPI {
  public static async getAll() {
      return await ApiController.get(ApiRoutes.getProductCategories) as AxiosResponse;
  }

  public static async getAllWithoutIcons() {
      return await ApiController.get(ApiRoutes.getProductCategoriesWithoutIcons) as AxiosResponse;
  }

  public static async getBasic() {
      return await ApiController.get(ApiRoutes.getBasicProductCategories) as AxiosResponse;
  }

  public static async getMaterialsByGroup(
    groupKey: string,
    params: MaterialsByGroupParams = {}
  ): Promise<AxiosResponse> {
    const { page = 1, perPage = 25, search = '' } = params;
    
    const query = new URLSearchParams({
      page: String(page),
      per_page: String(perPage),
      ...(search ? { search } : {}),
    });

    const endpointPath = ApiRoutes.getMaterialsByGroup(groupKey);

    return await ApiController.get(`${endpointPath}?${query.toString()}`) as AxiosResponse;
  }
}